import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const Text = styled.span`
  font-weight: 500;
  display: flex;
  align-items: center;
  &.success {
    color: ${props => props.theme.colors.green};
  }
  &.danger {
    color: ${props => props.theme.status.errorColor};
  }
  &.warning {
    color: ${props => props.theme.colors.orange};
  }
  &.feature {
    color: ${props => props.theme.palette.primary.main};
  }
`

const StatusText = ({ children, color }) => (
  <ThemeProvider theme={theme}>
    <Text className={color}>{children}</Text>
  </ThemeProvider>
)

export default StatusText
